import Events from "./Components/Core/Events";
import Forms from "./Components/Forms/forms";
import {favoritesInit, favoritesInitItem} from "./Components/Favorites/favorites";
import {compareInitItem} from "./Components/Compare/compare";
import Locations from './Components/Locations/locations';
import {cartInfoInit} from "./Components/basket/updateCartInfo";
import MmenuLight from "mmenu-light";
import Agent from "./Components/Core/agent";
import {searchAutocomplete} from "./Components/Search/search";
import {modal} from "./Components/UI/modal";
import {notice} from "./Components/UI/notice";
import {empty} from "./Components/Core/common";
import AuthApi from "./Components/Api/AuthApi";

const events = new Events();

cartInfoInit(events);

const form = new Forms(events);
let locations = new Locations(events);


document.querySelectorAll('.geo_location').forEach(item => item.addEventListener('click', () => {
    locations.getLocations(item);
}));

favoritesInit('.js_add_favorites', events);
//compareInit('.js_add_compare', events);


let initBasket;
if (document.querySelector('.js_add_to_cart')) {
    if (!initBasket) {
        initBasket = async () => await import("./Components/basket/basket");
    }

    initBasket()
        .then(f => f.initBasketEvents('.js_add_to_cart', events));
}

if (document.querySelector('.spoiler')) {
    document.querySelectorAll('.spoiler').forEach(item => {
        let btn = item.querySelector('.spoiler-btn');
        let container = item.querySelector('.spoiler-block');
        if (container.classList.contains('active')) {
            container.style.height = container.clientHeight + 'px';
        }
        btn.addEventListener('click', function (event) {
            event.preventDefault();
            btn.classList.toggle('active');
            event.target.closest('.spoiler').classList.toggle('active');
            if (!container.classList.contains('active')) {
                container.classList.add('active');
                container.style.height = 'auto';
                let height = container.clientHeight + 'px';
                container.style.height = '0px';
                setTimeout(function () {
                    container.style.height = height;
                }, 0);
            } else {
                container.style.height = '0px';
                setTimeout(function () {
                    container.classList.remove('active');
                }, 350);
            }
        })
    })
}
document.querySelectorAll('.dropdawn').forEach(item => {
    item.addEventListener("mouseover", function () {
        item.querySelector('.dropdawn-btn').classList.add('active');
        item.querySelector('.dropdawn-menu').classList.add('active');
    });
    item.addEventListener("mouseleave", function () {
        let timer = setTimeout(function () {
            item.querySelector('.dropdawn-menu').classList.remove('active');
            item.querySelector('.dropdawn-btn').classList.remove('active');
        }, 100);
        item.addEventListener('mouseover', function () {
            item.querySelector('.dropdawn-btn').classList.add('active');
            item.querySelector('.dropdawn-menu').classList.add('active');
            clearTimeout(timer);
        });
    });
});

let reInitBasket;
events.addListener('filter.search', null, () => {
    document.querySelectorAll('.js_add_favorites').forEach(item => favoritesInitItem(item));
    document.querySelectorAll('.js_add_compare').forEach(item => compareInitItem(item));
    if (!reInitBasket) {
        if (!initBasket) {
            initBasket = async () => await import("./Components/basket/basket");
        }

        initBasket().then(f => {
            reInitBasket = f.reInitBasketEvents;
            reInitBasket('.js_add_to_cart', events);
        });
    } else {
        reInitBasket('.js_add_to_cart', events);
    }


    form.initModalForm(document);

    document.querySelectorAll('.product-item').forEach(item => {
        if (!item.classList.contains('btn-char-initialized')) {
            item.classList.add('btn-char-initialized');
            let btn_char = item.querySelector('.btn-char');
            if (btn_char) {
                btn_char.addEventListener('click', () => {
                    item.querySelector('.flip-container').classList.toggle('active');
                });
            }
            let flip_close = item.querySelector('.flip-close');
            if (flip_close) {
                flip_close.addEventListener('click', () => {
                    item.querySelector('.flip-container').classList.remove('active');
                });
            }
        }
    });
});

if (document.querySelector('.js_filter_form')) {
    const filter = async () => await import("./Components/Filter/filter");
    filter().then(f => f.init(events));
}

const mobileMenuElement = document.querySelector("#mobile-menu");
const mobileMenuItemsElements = document.querySelectorAll('a[href="#mobile-menu"]');
if (mobileMenuElement && mobileMenuItemsElements) {
    let mobileMenu = new MmenuLight(mobileMenuElement);
    let closeMenu = mobileMenu.menu.querySelector('.mobile-menu__close');
    mobileMenu.navigation({
        title: "Меню",
        theme: "dark"
    });
    let drawerMenu = mobileMenu.offcanvas();
    mobileMenuItemsElements.forEach(mmenu => {
        mmenu.addEventListener('click', function (evnt) {
            evnt.preventDefault();
            drawerMenu.open();
        })
    });
    closeMenu.addEventListener('click', () => {
        drawerMenu.close();
    })
}

import intlTelInput from 'intl-tel-input';
import intlRu from "intl-tel-input/i18n/ru"


document.querySelectorAll('input[type="tel"]').forEach(input => {

    let wrapperBlock = input.closest('label');
    let parentBlock = wrapperBlock.parentElement;
    let country = document.createElement('div');
    country.classList.add('main-input__country');
    parentBlock.insertBefore(country, wrapperBlock.nextSibling);
    let iti = intlTelInput(input, {
        loadUtils: () => import("intl-tel-input/utils"),
        i18n: intlRu,
        initialCountry: "ru",
        autoPlaceholder: "aggressive",
        separateDialCode: true,
        strictMode: true,
        dropdownContainer: parentBlock.querySelector('.main-input__country'),
        hiddenInput: (telInputName) => ({
            phone: "phone"
        }),
    });

    input.style.paddingLeft = `71px`;

    input.addEventListener("input", () => {
        input.dataset.country_code = iti.getNumber(intlTelInput.utils.numberFormat.E164);
    });
})

if (document.querySelector('.scroll-item')) {
    document.addEventListener('scroll', () => {
        if (window.pageYOffset > 300) {
            document.querySelectorAll('.scroll-item').forEach(item => {
                item.classList.add('active');
            });
        } else {
            document.querySelectorAll('.scroll-item').forEach(item => {
                item.classList.remove('active');
            });
        }
    });
    document.querySelector('.scroll-item').addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
}

if (document.querySelector('.category-filter')) {
    let btn = document.querySelector('.btn-filter');
    let filter = document.querySelector('.category-filter');
    if(btn){
        document.addEventListener('click', (e) => {
            if (filter.classList.contains('active')) {
                if (e.target === filter) {
                    filter.classList.remove('active');
                }
            }
        });
        btn.addEventListener('click', () => {
            filter.classList.add('active');
        });
    }
}

const loadViewed = document.querySelector('.viewed');
if (loadViewed) {
    let observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (!loadViewed.querySelector('div')) {
                    Agent.post(`/api/v1/viewed`)
                        .then(e => e.json())
                        .then(e => {
                            if (e.success) {
                                loadViewed.innerHTML = e.data;
                                events.dispatch('filter.search');
                            }
                        })
                        .catch(e => console.log(e))
                        .finally(() => {
                            obs.unobserve(entry.target);
                        });
                }
            }
        });
    });

    observer.observe(loadViewed);
}

if (document.querySelector('.search-field')) {
    searchAutocomplete.init();
}

document.querySelectorAll('.js_open_autorize_form').forEach(item => item.addEventListener('click', () => {
    const options = {
        message: `<div class="modalc-call modal-block d-flex flex-column">
                    <span class="fs-24 fw-md">Вход и регистрация</span>
                    <form class="modal-form d-flex flex-column" name='authorization' method='post' autocomplete="off">
                        <div class="d-flex flex-column gap-12">
                            <span class="fs-16 fw-md">Введите номер телефона</span>
                            <label class="light-input">
                                <input type="tel" name="phone" placeholder="+7 (9__) ___-__-__" required>
                            </label>
                        </div>
                        <button type="button" class="btn-main js_recover_password">Получить СМС-код</button>
                         <div class="message w-100 d-flex justify-content-center">
                            <span class="fw-regular fs-14 text-danger js_message_label"></span>
                            <span class="fw-regular fs-14 text-danger js_message_sms_label d-none"> </span>
                        </div>
                    </form>
                </div>`,
        showEvent: function (to) {

            let inputPhone = to.querySelector('input[name="phone"]');
            let js_recover_password = to.querySelector('.js_recover_password');
            let js_message_label = to.querySelector('.js_message_label');
            let js_message_sms_label = to.querySelector('.js_message_sms_label');
            let form = to.querySelector('form');


            const authorization =  (userName, password)=> {
                js_message_label.innerHTML = '';

                if (empty(userName) || empty(password)) {
                    notice("Необходимо заполнить<br> обязательные поля.");
                    return;
                }

                AuthApi.authorization(userName, password)
                    .then(response => response.json())
                    .then(response => {
                        if (response.success) {
                            if (response.url) {
                                document.location.href = response.url;
                            } else {
                                document.location.reload();
                            }
                        } else {
                            notice(response.message);
                        }
                    })
                    .catch(() => {
                        notice("Не удалось сменить пароль.<br> Попробуйте позже <br>или<br> обратитесь к администратору.");
                    });
            };

            const timer = (timerPeriod, start, tick, finish) => {
                let counter = timerPeriod || 1;
                if (typeof start === 'function') {
                    start();
                }
                if (typeof tick === 'function') {
                    tick(counter);
                }
                let smsTimer = setInterval(function () {
                    counter--;
                    if (typeof tick === 'function') {
                        tick(counter);
                    }
                    if (counter === 0) {
                        counter = timerPeriod;
                        clearInterval(smsTimer);
                        if (typeof finish === 'function') {
                            finish();
                        }
                    }
                }, 1000);
            };

            const smsTimer = seconds => {
                timer(parseInt(seconds), function () {
                    js_recover_password.disabled = true;
                    js_message_sms_label.classList.remove('d-none');
                }, function (secondsLeft) {
                    js_message_sms_label.innerHTML = `Пароль был выслан на указанный номер. <br>Следующая отправка СМС возможна через <b>${secondsLeft}</b> секунд`;
                }, function () {
                    js_recover_password.disabled = false;
                    js_message_sms_label.classList.add('d-none');
                });
            };

            const recover_password = function () {

                let phone = inputPhone.dataset.country_code;
                if (empty(phone)) {
                    notice("Необходимо заполнить<br> обязательные поля.");
                } else {
                    js_recover_password.classList.add('preloader');
                    AuthApi.recoverPassword(phone)
                        .then(response => response.json())
                        .then(response => {
                            if (response.success) {
                                const authDialog = `
                                <div class="modalc-call modal-block d-flex flex-column">
                                    <span class="fs-24 fw-md">Отправили СМС-код на номер <span class='text-nowrap'>${phone}</span></span>
                                    <form class="modal-form d-flex flex-column" name="modal-registration" >
                                        <div class="d-flex flex-column gap-8">
                                            <span class="fs-14 fw-md">Введите код из СМС</span>
                                                <div class="modal-form__sms gap-8 js-sms_code">
                                                    <label class="emptyl-input">
                                                        <input class="text-center w-100" type="number" name="codeSym" maxlength="1" tabsms="1" required>
                                                    </label>
                                                    <label class="emptyl-input">
                                                        <input class="text-center w-100" type="number" name="codeSym" maxlength="1" tabsms="2" required>
                                                    </label>
                                                    <label class="emptyl-input">
                                                        <input class="text-center w-100" type="number" name="codeSym" maxlength="1" tabsms="3" required>
                                                    </label>
                                                    <label class="emptyl-input">
                                                        <input class="text-center w-100" type="number" name="codeSym" maxlength="1" tabsms="4" required>
                                                    </label>
                                                </div>
                                        </div>
                                        <button type="button" class="btn-main js_auth_button">Войти</button>
                                        <button type="button"  class="btn-emain border-2 js_form_reset">Получить код еще раз</button>
                                        <button type="button"  class="btn-inline href-pink fs-14 fw-md align-self-center text-decoration-underline js_form_reset">
                                                Изменить номер телефона
                                        </button>
                                    </form>
                                </div>`;
                                const showEventForAuthDialog = (to) => {
                                    let setValue = '';
                                    to.querySelectorAll('.js-sms_code').forEach(codeItem => {
                                        let inputs = codeItem.querySelectorAll('input[type= "number"]');
                                        let lastIndex = inputs.length;
                                        inputs.forEach(input => {
                                            inputs[0].removeAttribute('disabled');
                                            inputs[0].focus();
                                            inputs[0].classList.add('active');
                                            input.addEventListener('click', function (e) {
                                                if (!input.classList.contains('active')) {
                                                    e.preventDefault();
                                                }
                                                codeItem.querySelector(`input[class='active']`).focus();
                                            })
                                            input.addEventListener('keyup', function (e) {
                                                let inValue = input.value;
                                                let maxLength = parseInt(input.attributes['maxlength'].value);
                                                let length = inValue.length;
                                                let index = parseInt(input.getAttribute('tabsms'));
                                                let nextIndex = index + 1;
                                                let prevIndex = index - 1;
                                                if (length > 0) {
                                                    input.value = inValue.substring(0, 1);
                                                    // input.setAttribute('disabled', 'disabled');
                                                    input.classList.remove('active');
                                                    setValue += input.value;
                                                    if (index !== lastIndex) {
                                                        codeItem.querySelector(`input[tabsms='${nextIndex}']`).focus();
                                                        codeItem.querySelector(`input[tabsms='${nextIndex}']`).classList.add('active');
                                                    }

                                                } else if (length === 0 && prevIndex !== 0) {
                                                    // input.setAttribute('disabled', 'disabled');
                                                    input.classList.remove('active');
                                                    codeItem.querySelector(`input[tabsms='${prevIndex}']`).focus();
                                                    codeItem.querySelector(`input[tabsms='${prevIndex}']`).classList.add('active');
                                                }
                                                codeItem.setAttribute('value', setValue);
                                            })
                                            inputs[lastIndex - 1].addEventListener('keyup', function (e) {
                                                if (inputs[lastIndex - 1].value !== '') {
                                                    inputs.forEach(input => input.setAttribute('disabled', 'disabled'))
                                                }
                                            })
                                        });
                                    });

                                    to.querySelectorAll('.js_form_reset').forEach(codeItem => {
                                        codeItem.addEventListener('click', () => item.dispatchEvent(new Event('click')))
                                    });

                                    let js_auth_button = to.querySelector('.js_auth_button');
                                    js_auth_button.addEventListener('click', () => {
                                        if (setValue.trim().length > 3) {
                                            authorization(phone, setValue);
                                        }
                                    });
                                };
                                modal(authDialog, showEventForAuthDialog);

                            } else {
                                if (response.message && !response.seconds) {
                                    js_message_label.innerHTML = response.message;
                                }
                                if (response.seconds) {
                                    smsTimer(response.seconds);
                                }
                            }

                        })
                        .catch((e) => {
                            console.log(e)
                            notice("Не удалось отправить пароль.<br> Попробуйте позже<br> или<br> обратитесь к администратору.");
                        })
                        .finally(() => {
                            js_recover_password.classList.remove('preloader');
                        });
                }
            };


            inputPhone.addEventListener('input', () => {
                js_message_label.innerHTML = '';
            });



            js_recover_password.addEventListener('click', () => {
                js_message_label.innerHTML = '';
                recover_password();
            });

            form.addEventListener('submit', event => {
                event.stopPropagation();
                event.preventDefault();
            });
        }
    };

    modal(options);
}));

document.querySelectorAll('.js-city').forEach(item => {
    let cities = item.querySelector('.js-city__all');
    let active = item.querySelector('.js-city__active');
    active.addEventListener('mouseover', () => {
        cities.classList.add('active');
    })
    item.addEventListener('mouseleave', () => {
        cities.classList.remove('active');
    })
});
export default events;